import { render } from "./ClientePagoList.vue?vue&type=template&id=c77cfc2a&scoped=true"
import script from "./ClientePagoList.vue?vue&type=script&lang=js"
export * from "./ClientePagoList.vue?vue&type=script&lang=js"

import "./ClientePagoList.vue?vue&type=style&index=0&id=c77cfc2a&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\framacion_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c77cfc2a"]])

export default __exports__